export default "/images/vendor/flag-icons/flags/4x3/nc.svg?cd59091eac48fc8cc185fb055eba4da2";